import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./modalNPInfo.scss";
import IconNP from "../../../images/icons/nova_post.svg";
import { useGetPageUnloadQuery } from "../../../redux/services/noLoadingReqAPI";
import { Link, useNavigate } from "react-router-dom";

import { errorAlert, succsesDataChangeAlert } from "../../../alerts/alerts";
import { baseUrl, useSendFormMutation } from "../../../redux/services/crmAPI";
import { useEffect } from "react";

const ModalNPInfo = ({ setShowNpModal, showNpModal, orderId, ttn }) => {
    const navigate = useNavigate();

    const handleClose = () => setShowNpModal(false);

    const [subReason, setSubReason] = useState("0679cdb5-898e-11ea-a970-b8830365ade4");
    const [copiedStatus, setCopiedStatus] = useState(false);
    const [showReturn, setShowReturn] = useState(false);

    const { data: invoice } = useGetPageUnloadQuery("nova-poshta/invoice?ttn=" + ttn);
    const [sendForm, { isLoading, isError, error: sendFormError }] = useSendFormMutation();
    const { data: reasons } = useGetPageUnloadQuery("nova-poshta/return-reasons");
    const { data: reasonsSub } = useGetPageUnloadQuery(
        "nova-poshta/return-reasons-subtypes?reason_ref=49754eb2-a9e1-11e3-9fa0-0050568002cf"
    );

    const copyContentHandler = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedStatus(true);
            setTimeout(() => {
                setCopiedStatus(false);
            }, 1500);
            console.log("Content copied to clipboard");
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    const sendFormHandler = async () => {
        const formData = {
            ttn: ttn,
            payment_method: "Cash",
            reason_ref: "49754eb2-a9e1-11e3-9fa0-0050568002cf",
            subreason_ref: subReason,
            address_ref: "47402ea4-e1c2-11e3-8c4a-0050568002cf",
        };

        await sendForm({
            body: formData,
            url: "nova-poshta/return",
            method: "POST",
        }).unwrap();

        if (!isError) {
            succsesDataChangeAlert();
        }
    };

    useEffect(() => {
        if (sendFormError?.data?.success === false && sendFormError) {
            errorAlert();
        }
    }, [sendFormError]);

    return (
        <Modal show={showNpModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div>
                        <img
                            src={IconNP}
                            alt="NP"
                            style={{ width: "39px", height: "39px", marginRight: "30px", marginTop: "-8px" }}
                        />
                        Електронна Накладна #{orderId}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {invoice && (
                    <div className="modal-body">
                        <div className="text-center">
                            <div className="text-start">
                                Електронну накладну вже було сформовано. натисніть на номер, для того, щоб скопіювати
                                його до буферу обміну.
                            </div>

                            <div className="row mt-3">
                                <div className="col-6">
                                    <div
                                        className="new_ttn_number"
                                        data-clipboard-text="20450719737140"
                                        onClick={() => copyContentHandler(invoice.Number)}
                                    >
                                        <i className="bi bi-clipboard2-plus-fill"></i>
                                        {copiedStatus ? "Скопійовано..." : invoice.Number}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="print_ttn" data-order_id="180828">
                                        <i className="bi bi-printer"></i>

                                        <a
                                            href={
                                                baseUrl + "nova-poshta/invoice/pdf?password=NASDBkhvzxhc1263&ttn=" + ttn
                                            }
                                            download
                                            target="_self"
                                            className="pdfLink"
                                        >
                                            Друк накладної
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 my-3">
                                    <div className="cargo_return_ttn" onClick={() => setShowReturn(!showReturn)}>
                                        <i className="bi bi-arrow-clockwise"></i> Оформити повернення посилки
                                    </div>
                                </div>
                            </div>
                            {showReturn && (
                                <div className="row mb-3">
                                    <div className="col-6 text-start">
                                        <label className="form-label">Причина повернення:</label>

                                        <select
                                            className="form-select"
                                            value={subReason}
                                            onChange={(e) => setSubReason(e.target.value)}
                                        >
                                            <option value="0679cdb5-898e-11ea-a970-b8830365ade4">Автоповернення</option>
                                            <option value="49754ec8-a9e1-11e3-9fa0-0050568002cf">
                                                Відправлення не відповідає замовленню, не підійшло
                                            </option>
                                            <option value="49754ec6-a9e1-11e3-9fa0-0050568002cf">
                                                Відправник скасував доставку відправлення
                                            </option>
                                            <option value="49754ec4-a9e1-11e3-9fa0-0050568002cf">
                                                Одержувач не оформляв замовлення
                                            </option>
                                        </select>
                                    </div>
                                    <div className="col-6 text-left">
                                        <label className="form-label">&nbsp; </label>
                                        <div className="form-group saves_block">
                                            <div className="btn btn-primary form-control" onClick={sendFormHandler}>
                                                {isLoading ? "Опрацювання" : "Оформити повернення"}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 results"></div>
                                </div>
                            )}
                            <table className="table table-striped table-sm text-left">
                                <tbody>
                                    <tr>
                                        <td>Відправник</td>
                                        <td>
                                            {invoice.SenderContactPerson}
                                            {/* (
                                            <a href="/files/np_accounts/380964994400.jpg" target="_blank">
                                                Карта клієнта
                                            </a>
                                            ) */}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Вага, кг</td>
                                        <td>{invoice.Weight}</td>
                                    </tr>
                                    <tr>
                                        <td>Отримувач</td>
                                        <td>
                                            <a href="/client?id=60485">{invoice.RecipientContactPerson}</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тип оплати</td>
                                        <td>{invoice.PayerType}</td>
                                    </tr>
                                    <tr>
                                        <td>Телефон отримувача</td>
                                        <td>{invoice.RecipientContactPhone}</td>
                                    </tr>
                                    <tr>
                                        <td>Отрієнтовна дата прибуття</td>
                                        <td>{invoice?.ScheduledDeliveryDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Вартість доставки</td>
                                        <td>{invoice.CostOnSite}</td>
                                    </tr>
                                    <tr>
                                        <td>Дата створення</td>
                                        <td>{invoice.CreateTime}</td>
                                    </tr>
                                    <tr>
                                        <td>Дата отримання</td>
                                        <td>{invoice.RecipientDateTime}</td>
                                    </tr>
                                    <tr>
                                        <td>Місто відправника</td>
                                        <td>{invoice.CitySenderDescription}</td>
                                    </tr>
                                    <tr>
                                        <td>Місто отримувача</td>
                                        <td>{invoice.CityRecipientDescription}</td>
                                    </tr>
                                    <tr>
                                        <td>Опис</td>
                                        <td>{invoice.Description}</td>
                                    </tr>
                                    <tr>
                                        <td>Оголошена вартість</td>
                                        <td>{invoice.Cost}</td>
                                    </tr>
                                    <tr>
                                        <td>Статус</td>
                                        <td>{invoice.StateName}</td>
                                    </tr>
                                    <tr>
                                        <td>Сума повернення</td>
                                        <td>{invoice.BackwardDeliverySum}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ModalNPInfo;
